import { DataService } from "app/services/data.service";
import { FrontEndService } from "app/services/front-end.service";
import { Component, OnInit, ViewChild } from '@angular/core';
import { LogService } from 'app/services/log.service';
import { UserProfileService } from "../../services/user-profile.service";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { StateService } from '@uirouter/angular';

@Component({
    selector: 'app-view-user-profile-list',
    templateUrl: './view-user-profile-list.component.html',
    styleUrls: ['./view-user-profile-list.component.scss']
})
export class ViewUserProfileListComponent implements OnInit {

    @ViewChild('header') header;

    fullScreenLoader = false;
    userProfileList = [];
    userProfileListMaster = [];
    closeResult: string;
    search_string = "";
    next;

    private static getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    constructor(
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private modalService: NgbModal,
        private userProfileService: UserProfileService,
        private stateService: StateService,
        private logService: LogService
    ) { }

    ngOnInit() {
        if (parseInt(this.dataService.currentUser['role'], 10) > 1 && !this.dataService.currentUser['can_view_profile']) {
            this.stateService.go("Forbidden");
        } else {
            this.getProfiles();
        }
    }

    getProfiles (isExport = false) {
        // Show loader only for the first time
        this.fullScreenLoader = this.userProfileList.length === 0;
        const offset = this.next ? this.userProfileList.length : 0;
        this.userProfileService.getProfiles(isExport, offset,  (response) => {
            if (response.status) {
                this.userProfileListMaster = this.userProfileListMaster.concat(response.data);
                this.userProfileList = this.userProfileList.concat(response.data);
                this.next = response.next;
            }

            this.fullScreenLoader = false;
        });
    }

    /**
     * Search in profiles object
     * @param event
     */
    searchProfiles(event) {
        this.userProfileList = this.userProfileListMaster.filter((x) => {
            for (const key in x) {
                if (x.hasOwnProperty(key) && x[key] !== undefined && x[key] !== null) {
                    if (x[key].toString().toLowerCase().search(event.toString().toLowerCase()) !== -1) {
                        return x
                    }
                }
            }
        });
    }

    deleteProfile(profileId) {
        this.front_end_service.confirmAlert('confirm', 'delete_profile_confirmation', 'warning', (result) => {
            if (result.value) {
                this.fullScreenLoader = true;
                this.userProfileService.deleteProfile(profileId, (response) => {
                    if (response.status) {
                        this.front_end_service.addToast(
                            "Success",
                            "profile_deleted_successfully",
                            "success"
                        );

                        const index = this.userProfileListMaster.findIndex(profile => profile.id === profileId);
                        this.userProfileListMaster.splice(index, 1);
                    }
                    this.fullScreenLoader = false
                });
            }
        });
    }

    open(content) {
        this.modalService.open(content, { size: 'lg' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${ViewUserProfileListComponent.getDismissReason(reason)}`;
        });
    }

    uploadDone() {
        // Handle upload of file here
    }

    uploadDocuments(files) {
        this.fullScreenLoader = true;
        const data = {
            "file": files[0]
        };
        this.userProfileService.importProfile(data, (response) => {
            this.fullScreenLoader = false;
            if (response.status) {
                this.front_end_service.addToast(
                    "Success",
                    "profiles_imported_successfully",
                    "success"
                );
                this.getProfiles();
            } else {
                let message = "";

                (response.data as Array<any>).forEach((responseData) => {
                    if (responseData.hasOwnProperty("message")) {
                        Object.keys(responseData.message).forEach((key) => {
                            message += key + ": " + response.data[0].message[key] + "<br>";
                        });
                        if (response.data.indexOf(responseData) !== (response.data.length - 1)) {
                            message += "<hr>";
                        }
                    }
                });

                if (message === "") {
                    message = response.message;
                }

                this.front_end_service.showAlert(
                    "Error",
                    message,
                    false
                );
            }
        });
    }

    /**
     * Fetch more profiles on scroll
     */
    onScroll() {
        if (this.next) {
            this.getProfiles();
        }
    }
}
